/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { type MutableRefObject, useCallback, useRef } from 'react'
import { useEventListener } from 'usehooks-ts'

interface Coordinates {
  x: number
  y: number
}

export const useMouseMoveOnImage = ({
  active,
}: {
  active: boolean
}): {
  imgRef: MutableRefObject<HTMLImageElement | null>
  moveImage: () => void
} => {
  const imgRef = useRef<HTMLImageElement | null>(null)

  type Points = [number, number]
  const mousePosition = useRef<Points>()

  const moveImage = useCallback(() => {
    if (!active) {
      return
    }

    if (!imgRef.current) {
      return
    }

    if (!mousePosition.current) {
      return
    }

    const { width, height } = imgRef.current.getBoundingClientRect()
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight

    const mousePositionX = mousePosition.current[0]
    const mousePositionY = mousePosition.current[1]

    const normalizedX = mousePositionX / windowWidth
    const normalizedY = mousePositionY / windowHeight

    if (width - windowWidth > 0) {
      imgRef.current.style.left = `-${normalizedX * (width - windowWidth)}px`
    } else {
      imgRef.current.style.left = 'auto'
    }
    if (height - windowHeight > 0) {
      imgRef.current.style.top = `-${normalizedY * (height - windowHeight)}px`
    } else {
      imgRef.current.style.top = 'auto'
    }
  }, [active])

  const listener = (e: Coordinates) => {
    mousePosition.current = [e.x, e.y]
    moveImage()
  }

  useEventListener('mousemove', listener)

  return { imgRef, moveImage }
}
